import getUserInfo from "@/api/chat/getUserInfo";

let getOtherInfoByFrom = function(fromType,fromId,isMe){
	return new Promise( (resolve) => {
		if (isMe) {
			resolve()
		}else{
			let from = fromType+','+fromId
			let otherInfo = JSON.parse(localStorage.getItem('otherInfo') || '[]')
			let userOtherinfo = otherInfo.find(x=> x.from===from)
			let nowTime = new Date().getTime()
			let expireTime = nowTime+(1000*60*60*24*7)//缓存一周

			if (userOtherinfo && userOtherinfo.expireTime > nowTime){
				resolve(userOtherinfo)
			}
			else{//如果没有缓存对方信息 或 缓存过期，则重新获取
				getUserInfo(fromType,fromId).then(res=>{
					let data = res.data
					userOtherinfo={
						from:from,
						nickname:data.nickname,
						headImage:data.headImage,
						expireTime:expireTime
					}
					otherInfo.push(userOtherinfo)
					localStorage.setItem('otherInfo',JSON.stringify(otherInfo))
					resolve(userOtherinfo)
				})
			}
		}
	})
}
export {
	getOtherInfoByFrom
}